// extracted by mini-css-extract-plugin
export default {"container":"Team_container__rWAZc"};